/* eslint-disable no-extend-native */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState, useEffect } from "react";
import NftPreview from "./NftPreview";
import MintFooter from "./MintFooter";
import Catalogue from "./Catalogue";
import Name from "./Name";
import Distribution from "./Distribution";
import PieDist from "./PieDist";
import FinalCheck from "./FinalCheck";
import Spinner from "../Spinner";
import { useNavigate } from "react-router-dom";
import error from "../../../../config/error.json";
import { logError } from "../../../../utils/log";
import Modal from "../Modal/Modal";
import Popup from "../Modal/Popup";
import Error from "../Modal/Error";
import Warning from "../Modal/Warning";
import { sha256 } from "crypto-hash";
import axios from "axios";

import {
  getBackgrounds,
  getPatterns,
  getLayers,
  getLayerChoices,
  getApprovedNames,
  getRarityList,
  getPreviewImage,
} from "../../../../utils/services";
import constant from "../../../../utils/constants";
import { v4 as uuidv4 } from "uuid";
import { addLayerChoiceDynamically } from "../../../../utils/common";
import { usePreview } from "../../../../context/PreviewContextProvider";
import { useWallet } from "../../../../context/WalletContextProvider";
import { useGlobal } from "../../../../context/GlobalContextProvider";

const Mint = () => {
  const {
    campaign,
    artPack,
    data,
    previewCard,
    updatePreviewCard
  } = usePreview();
  const { apiConstants } = useWallet();
  const { initialDistroPreset } = useGlobal();

  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState([]);
  const [patterns, setPatterns] = useState([]);
  const [layers, setLayers] = useState([]);
  const [sliders, setDefaultSlider] = useState([]);
  const [presetDistribution, setPresetDistribution] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [pieData, setPieData] = useState([0, 0, 0, 0]);
  const [preset, setPreset] = useState("");
  const [showPreset, setShowPreset] = useState(true);
  const [names, setNames] = useState([]);
  const [stepdata, setData] = useState([]);
  const [identifier, setIdentifier] = useState("");
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [stepState, setStep] = useState(0);
  const [previewLink, setPreviewLink] = useState("");
  const [errShow, setErrShow] = useState(false);
  const [warnShow, setWarnShow] = useState(false);
  const [errMessage, setErrorMessage] = useState();
  const [rarityList, setRarityList] = useState([]);
  const [removedSteps, setRemovedSteps] = useState({});
  const [layerWiseChoice, setLayerWiseChoice] = useState({});
  const [previewQuery, setPreviewQuery] = useState();
  const [spinner, setSpinner] = useState(false);
  const [rarityData, setRarityData] = useState({
    background: {},
    pattern: {},
    layer: {},
    layerchoice: {},
    layerclass: {},
    layerstylecolor: {},
    name: {},
  });
  const [layerChoicesAreSingle, setLayerChoicesAreSingle] = useState(0);
  const [autoPreview, setAutoPreview] = useState([]);
  const [delayedName, setDelayName] = useState("");
  const [distroColors, setDistroColors] = useState({
    beneficiary_color: "#504C4C",
    artist_color: "#918787",
    sponsor_color: "#C7C2C0",
    seller_color: "#E5DFDD",
  });

  const validatePatternAndLayers = () => {
    const alllayers = layers.filter(
      (layer) => layer.pattern_id === selectedItems?.pattern?.pattern_id
    );
    return alllayers.length === layers.length;
  };

  const getDefaultSlider = async () => {
    const allRes = await fetch(`/api/preview/home/${campaign?.campaign_id}`);
    const allData = await allRes.json();
    const defaultSliders = [
      {
        name: "Beneficiary",
        color: distroColors.beneficiary_color,
        defaultValue: allData.data.beneficiary_distro_min,
        min: allData.data.beneficiary_distro_min,
        max: allData.data.beneficiary_distro_max,
        category: "beneficiary",
      },
      {
        name: "Artist",
        color: distroColors.artist_color,
        defaultValue: allData.data.artist_distro_min,
        min: allData.data.artist_distro_min,
        max: allData.data.artist_distro_max,
        category: "artist",
      },
      {
        name: "Sponsor",
        color: distroColors.sponsor_color,
        defaultValue: allData.data.sponsor_distro_min,
        min: allData.data.sponsor_distro_min,
        max: allData.data.sponsor_distro_max,
        category: "fundraiser",
      },
      /*{
        name: "Seller",
        color: distroColors.seller_color,
        defaultValue:
          100 -
          (allData.data.sponsor_distro_min +
            allData.data.beneficiary_distro_min +
            allData.data.artist_distro_min),
        min: allData.data.seller_distro_min,
        max: allData.data.sponsor_distro_max,
        category: "seller",
      },*/
    ]
    return defaultSliders
  }

  const getPresetDistribution = async () => {
    let distroPresetData = {};
    if (campaign?.campaign_id) {
      const distroPresetRes = await fetch(
        `/api/campaign/${campaign?.campaign_id}/distropreset`
      );

      if (distroPresetRes.status === 200) {
        distroPresetData = await distroPresetRes.json();
        if (distroPresetData?.length > 0) {
          distroPresetData = distroPresetData.map((preset) => ({            
            ...preset,
            artist_distro: preset.artist_distro - apiConstants.reddevcut,
            sponsor_distro: preset.sponsor_distro - apiConstants.reddevcut,
          }));
        }
      }
    }
    else {
      distroPresetData = [{
        artist_distro: 16,
        beneficiary_distro: 80,
        preset_name: "Distro",
        seller_distro: 0,
        sponsor_distro: 4
      }]
    }

    return distroPresetData
  }


  useEffect(() => {
    const getData = async () => {
      const distroColorRes = await fetch(
        `/api/distrocolor/campaign/${campaign?.campaign_id}`
      );
      let distroColorData = {};
      if (distroColorRes.status === 200) {
        distroColorData = await distroColorRes.json();
      }

      if (Object.keys(distroColorData).length !== 0) {
        const updatedDistroColors = {
          beneficiary_color: distroColorData.beneficiary_color,
          artist_color: distroColorData.artist_color,
          sponsor_color: distroColorData.sponsor_color,
          seller_color: distroColorData.seller_color,
        };
        setDistroColors(updatedDistroColors);
      }
      const _dSlider = await getDefaultSlider();
      setDefaultSlider(_dSlider);
      setPresetDistribution(await getPresetDistribution());
    };

    if (campaign?.art_pack_id) { getData() }
    else {
      setDefaultSlider([
        {
          name: "Beneficiary",
          category: "beneficiary",
        },
        {
          name: "Artist",
          category: "artist",
        },
        {
          name: "Sponsor",
          category: "fundraiser",
        },
        /*{
          name: "Seller",
          category: "seller",
        },*/
      ])
      setPresetDistribution([{
        artist_distro: initialDistroPreset.artist_distro - apiConstants.reddevcut,
        beneficiary_distro: initialDistroPreset.beneficiary_distro,
        preset_name: "Distro",
        seller_distro: initialDistroPreset.seller_distro,
        sponsor_distro: initialDistroPreset.sponsor_distro - apiConstants.reddevcut
      }])
    }
  }, [campaign]);



  const artOptionstemp = [
    {
      title: constant.BACKGROUND_COLOR,
      identifier: "background",
      category: "background",
      widget: "catalogue",
      preview: true,
      navButton: constant.BACKGROUND_COLOR,
      getData: async function () {
        try {
          if (backgroundColor.length === 0) {
            if (artPack?.art_pack_id) {
              const bg = await getBackgrounds(campaign?.campaign_id, artPack?.art_pack_id);
              setBackgroundColor(bg);
              setData([...bg]);
            }
          } else {
            setData([...backgroundColor]);
          }
        } catch (err) {
          logError(err);
        }
      },
    },
    {
      title: constant.PATTERN,
      identifier: "pattern",
      category: "pattern",
      widget: "catalogue",
      preview: true,
      navButton: constant.PATTERN,
      getData: async function () {
        if (patterns.length === 0) {
          if (artPack?.art_pack_id) {
            const pattern = await getPatterns(artPack?.art_pack_id);
            setPatterns(pattern);
            setData([...pattern]);
          }
        } else {
          setData([...patterns]);
        }

      },
    },
    {
      title: constant.NAME,
      identifier: "name",
      category: "name",
      widget: "name",
      preview: false,
      navButton: constant.NAME,
      getData: async function () {
        if (names.length === 0) {
          if (artPack?.art_pack_id) {
            const names = await getApprovedNames(artPack?.art_pack_id);
            setNames(names);
          }
        }

      },
    },
    {
      title: constant.PICK_DISTRO,
      identifier: "distribution",
      category: "distribution",
      widget: "distribution",
      preview: false,
      navButton: constant.ALTER_EGO,
      getData: async function () {

      },
    },
    {
      title: constant.FINAL_TEXT,
      identifier: "confirmation",
      category: "confirmation",
      navButton: constant.FINAL_CHECK,
      widget: "final",
      preview: false,
      getData: function () {

      },
    },
  ];

  const [artOptions, setArtOptions] = useState(artOptionstemp);
  useEffect(() => {
    const constructLayerChoices = async () => {
      if (layers.length !== 0) {
        let start = stepState + 1;
        let layerChoiceCount = 0;
        for (let count = 0; count < layers.length; count++) {
          let layerChList = layerWiseChoice[layers[count].layer_id];
          if (!layerChList) {
            layerChList = await getLayerChoices(layers[count].layer_id);
            setLayerWiseChoice((previous) => ({
              ...previous,
              [layers[count].layer_id]: layerChList,
            }));
          }
          if (layerChList.length === 1) {
            setLayerChoicesAreSingle(++layerChoiceCount);
            if (layerChList[0])
              setRemovedSteps((removedSteps) => ({
                ...removedSteps,
                [`layerchoice${count}`]: {
                  ...layerChList[0],
                  category: "layerchoice",
                  step: start,
                },
              }));
          } else {
            const dynamicLayerChoice = await addLayerChoiceDynamically(
              count,
              layers,
              setData,
              layerChList
            );
            artOptionstemp.insert(start++, dynamicLayerChoice);
            setArtOptions(artOptionstemp);
            setRarityData((obj) => ({
              ...obj,
              [dynamicLayerChoice.identifier]: {},
            }));
          }
        }
        if (layerChoiceCount > 0 && layerChoiceCount === layers.length)
          setDelayName(constant.NAME);

      }
      if (presetDistribution.length === 1) {
        let start = stepState + 1
        setRemovedSteps((removedSteps) => ({
          ...removedSteps,
          [`distribution`]: {
            ...presetDistribution[0],
            category: "distribution",
            step: start,
          },
        }));
      }
    };
    constructLayerChoices();
  }, [patterns, layers]);

  useEffect(() => {
    artOptions[stepState].getData();
    setTitle(artOptions[stepState].title);
    setIdentifier(artOptions[stepState].identifier);
    setCategory(artOptions[stepState].category);
  }, [stepState]);

  // Re-run getData when artPack becomes available
  useEffect(() => {
    if (artPack?.art_pack_id && stepState === 0) {
      artOptions[stepState].getData();
    }
  }, [artPack]);

  useEffect(() => {
    const previewData = async () => {
      if (artOptions[stepState].preview || autoPreview.length) await preview();
    };
    if (Object.keys(selectedItems).length > 0) previewData();
  }, [JSON.stringify(selectedItems)]);


  useEffect(() => {
    const updateLayer = async () => {
      const layers = await getLayers(selectedItems.pattern.pattern_id);
      setLayers(layers);
    };
    if (selectedItems?.pattern?.pattern_id) {

      updateLayer();
      setArtOptions(artOptionstemp);
    }
  }, [selectedItems?.pattern?.pattern_id]);

  useEffect(() => {
    const getRarity = async () => {
      let rarity = await getRarityList(campaign?.campaign_id);
      setRarityList(rarity);

    };
    if (campaign?.campaign_id) getRarity();
  }, [campaign]);

  const openErrorModal = (err) => {
    setErrorMessage(err);
    setErrShow(!errShow);
  };

  const closeErrorModal = () => {
    setErrShow(!errShow);
  };

  const openWarnModal = () => {
    setWarnShow(!warnShow);
  };

  const closeWarnModal = () => {
    setWarnShow(!warnShow);
  };

  const createPreviewFile = async () => {
    if (previewCard?.length && previewCard?.length >= data.max_count) {
      setWarnShow(!warnShow)
    }
    else {
      setSpinner(true);
      const base64Res = await fetch(previewLink);
      const blob = await base64Res.blob();
      const file = new File([blob], "preview.png", { type: "image/png" });
      const date = Date.now();
      const sha = await sha256(`${date}`);
      const encryptedName = `${sha}.png`;
      const formData = new FormData();
      formData.append("file", file, encryptedName);
      const uploadRes = await axios.post(`/api/file/upload`, formData);
      const previewRes = await fetch(`/api/mintpreview/previewnftdata`, {
        method: "POST",
        body: JSON.stringify({
          nft_name: selectedItems.name
            ? `${selectedItems.name.approved_name} #${selectedItems.name.display_order}`
            : "",
          price: selectedItems.background
            ? selectedItems.background.price
              ? selectedItems.background.price
              : 0
            : "",
          preset_distribution:
            pieData.length > 0
              ? JSON.stringify([
                {
                  value: Math.round(pieData[0]),
                  color: distroColors.beneficiary_color,
                },
                {
                  value: Math.round(pieData[1]),
                  color: distroColors.artist_color,
                },
                {
                  value: Math.round(pieData[2]),
                  color: distroColors.sponsor_color,
                },
                {
                  value: Math.round(pieData[3]),
                  color: distroColors.seller_color,
                },
              ])
              : `[]`,
          campaing_id: campaign?.campaign_id,
          image: encryptedName,
          preset_name: preset,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })

      let binaryString = "";
      const arrayBuffer = new Uint8Array(uploadRes.data.image.data);
      for (let i = 0; i < arrayBuffer.length; i++) {
        binaryString += String.fromCharCode(arrayBuffer[i]);
      }
      const imageBase64 = btoa(binaryString);
      const previewData = await previewRes.json()
      const mintedPreviewCard = {
        id: `${uploadRes.data.id}-${previewData.body.data.preview_nft_data_id}`,
        name: selectedItems.name
          ? `${selectedItems.name.approved_name} #${selectedItems.name.display_order}`
          : "",
        price: selectedItems.background
          ? selectedItems.background.price
            ? selectedItems.background.price
            : 0
          : "",
        image: `data:image/png;base64,${imageBase64}`,
        tokenId: 1,
        siteTokenIndex: 1,
        distPresetName: preset,
        forSale: Math.random() < 0.5,
        originalPrice: selectedItems.background
          ? selectedItems.background.price
            ? selectedItems.background.price
            : 0
          : "",
        address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
      }
      updatePreviewCard([...previewCard, mintedPreviewCard])
      setSpinner(false);
      navigate("/preview-home/my");
    }
  };

  const returnToArtPack = () => {
    navigate("/artist/background")
  }

  const returnToCampaign = () => {
    const campaignId = sessionStorage.getItem('previewCampaignId');
    const createMode = sessionStorage.getItem('previewCreateMode');
    const formDraft = sessionStorage.getItem('previewFormDraft');

    if (campaignId) {
      // Return to specific campaign form (editing)
      navigate(`/sponsor/campaign`, { state: { editCampaignId: campaignId } });
    } else if (createMode && formDraft) {
      // Return to create form with draft data
      navigate(`/sponsor/campaign`, { state: { createMode: true, formDraft: formDraft } });
    } else {
      // Return to campaign list
      navigate("/sponsor/campaign");
    }
  }

  const restart = () => {
    setStep(0)
  }
  const prevStep = () => {
    if (
      artOptions[stepState - 1].category === "pattern" &&
      layerChoicesAreSingle !== layers.length
    )
      setDelayName("");
    if (stepState !== 0) {
      setData([]);

      if (artOptions[stepState - 1].category === "distribution" && presetDistribution.length === 1) {
        setStep(stepState - 2)
      }
      else {
        setStep(stepState - 1);
      }
    }
  };

  const nextStep = () => {
    let errorMsg = "";
    if (artOptions[stepState + 1].category === "layerchoice")
      setDelayName(constant.NAME);
    if (validateSelection()) {
      if (stepState < artOptions.length - 1) {
        setData([]);

        const autoPreview = Object.keys(removedSteps).filter(
          (k) => removedSteps[k].step === stepState + 1
        );
        setAutoPreview(autoPreview);
        for (const selection of autoPreview) {
          setSelectedItems((selectedItems) => ({
            ...selectedItems,
            [selection]: removedSteps[selection],
          }));
        }
        if (artOptions[stepState + 1].category === "distribution" && presetDistribution.length === 1) {
          let pd = []
          pd[0] = presetDistribution[0].beneficiary_distro
          pd[1] = presetDistribution[0].sponsor_distro
          pd[2] = presetDistribution[0].artist_distro
          pd[3] = presetDistribution[0].seller_distro
          setPieData([...pd])
          setPreset(presetDistribution[0].preset_name)
          setStep(stepState + 2)
        }
        else {
          setStep(stepState + 1);
        }
        window.scrollTo(0, 0);
      }
    } else {
      errorMsg = error.MINT_MANDATORY_OPTION_SELECT;
      openErrorModal(errorMsg);
    }
  };

  const validateSelection = () => {
    if (artOptions[stepState].category === "pattern") {
      if (artOptions[stepState + 1].category === "layerchoice") {
        if (!validatePatternAndLayers()) {
          return false;
        }
        return true;
      } else {
        if (layers.length !== 0) {
          if (
            layerChoicesAreSingle > 0 &&
            layerChoicesAreSingle === layers.length
          )
            return true;
          return true;
        }
        else if (selectedItems["pattern"]) {
          return true
        }
      }
    } else if (selectedItems[artOptions[stepState].identifier]) {
      return true;
    }
    return false;
  };

  const preview = async () => {
    setLoader(true);
    previewQuery?.cancel();
    const body = { data: getPreviewData(), file: uuidv4() };
    const q = getPreviewImage(body);
    setPreviewQuery(q);
    q.then((base64) => {
      setLoader(false);
      setPreviewLink(base64);
    }).catch(() => {
      setLoader(false);
    });
  };

  const setUserSelection = async (selected) => {
    let _update = Object.assign(selectedItems, selected);
    setSelectedItems({ ..._update });
  };

  const getPreviewData = () => {
    let data = [];
    for (const choice in selectedItems) {
      const { category } = selectedItems[choice];
      if (category === "background") {
        data.push({
          value: selectedItems[choice].color_hex_code,
          type: "color",
          class: "background",
        });
      } else if (category === "pattern") {
        data.push({
          value: selectedItems[choice].thumbnail_url,
          type: "layer",
          class: "patterns",
          name: `pattern${selectedItems[choice].pattern_id}`,
        });
      } else if (category === "layerchoice") {
        data.push({
          value: selectedItems[choice].thumbnail_url,
          type: "layer",
          class: "patterns",
          name: `layer${selectedItems[choice].layer_choice_id}`,
        });
      }
    }
    return data;
  };

  const renderWarnPopup = () => {
    return (
      <Modal show={warnShow} type={"warn"}>
        <Popup type={"warn"}>
          <Warning
            onClose={closeWarnModal}
            text="You have already minted maximum number of NFTs."
          />
        </Popup>
      </Modal>
    );
  };

  const renderErrorPopup = () => {
    return (
      <Modal show={errShow}>
        <Popup>
          <Error err={errMessage} onClose={closeErrorModal} />
        </Popup>
      </Modal>
    );
  };

  const renderStep = () => {
    if (artOptions[stepState].widget === "catalogue") {
      return (
        <Catalogue
          category={category}
          identifier={identifier}
          data={stepdata}
          setUserSelection={setUserSelection}
          selectedItems={selectedItems}
          title={title}
          rarityList={rarityList}
          rarityData={rarityData}
          setRarityData={setRarityData}
          campaign={campaign}
        />
      );
    } else if (artOptions[stepState].widget === "name") {
      return (
        <Name
          nameList={names}
          setUserSelection={setUserSelection}
          selectedItems={selectedItems}
          title={title}
          data={data}
        />
      );
    } else if (artOptions[stepState].widget === "distribution") {
      return (
        <Distribution
          setUserSelection={setUserSelection}
          distribution={presetDistribution}
          sliders={sliders}
          pieData={pieData}
          setPieData={setPieData}
          preset={preset}
          setPreset={setPreset}
          showPreset={showPreset}
          setShowPreset={setShowPreset}
          setDefaultSlider={setDefaultSlider}
          title={title}
          selectedItems={selectedItems}
        />
      );
    } else if (artOptions[stepState].widget === "final") {
      return (
        <FinalCheck
          selectedItems={selectedItems}
          setUserSelection={setUserSelection}
          artOptions={artOptions}
          sliders={sliders}
          preset={preset}
          title={title}
          rarityData={rarityData}
          previewLink={previewLink}
          input={selectedItems}
        />
      );
    }
  };

  const renderStepPreview = () => {
    if (["catalogue", "name", "final"].includes(artOptions[stepState].widget)) {
      return (
        <NftPreview
          loader={loader}
          input={selectedItems}
          previewLink={previewLink}
          pieData={pieData}
          colors={distroColors}
          preset={preset}
          widget={artOptions[stepState].widget}
          data={data}
        />
      );
    } else if (["distribution"].includes(artOptions[stepState].widget)) {
      return (
        <PieDist
          pieData={pieData}
          colors={distroColors}
          preset={preset}
          sliders={sliders}
          previewLink={previewLink}
          widget={artOptions[stepState].widget}
        />
      );
    }
  };

  const showSponsorTitle = () => {
    const previewContext = sessionStorage.getItem('previewContext');

    // Show "Art Pack Preview" for campaign form previews (both create and edit)
    if (previewContext === 'campaign-form') {
      return "Art Pack Preview";
    }

    // Show normal title for navbar previews
    if (data.nft_name === "" || data.nft_name === null) {
      return "Mint a NFT"
    }
    else {
      return `Mint a ${data.nft_name}`
    }
  }

  const renderContent = () => {
    return (
      <section id="mint" className="page-settings">
        <Spinner spinner={spinner} />
        {renderErrorPopup()}
        {warnShow && renderWarnPopup()}

        <h1
          className="mint__title title-styles-nocaptial"
          style={{ color: data.web_main_color }}
        >
          {campaign?.campaign_id ? showSponsorTitle() : "Art Pack Preview"}

        </h1>
        <div className="mint__box">
          <div className="mint__box-wrapper">
            <div className="mint__steps">
              <div className="mint__steps-left">
                {renderStep()}
              </div>
              <div className="mint__steps-right">{renderStepPreview()}</div>
            </div>
            <MintFooter
              nextHover={`Please select a ${title} first`}
              nextButton={stepState !== (artOptions.length - 1) && artOptions[stepState + 1].category === "distribution" && presetDistribution.length === 1 ? artOptions[stepState + 2]?.navButton : artOptions[stepState + 1]?.navButton || delayedName}
              backButton={stepState !== 0 && artOptions[stepState - 1].category === "distribution" && presetDistribution.length === 1 ? artOptions[stepState - 2]?.navButton : artOptions[stepState - 1]?.navButton || delayedName}
              stepTotal={artOptions.length - 1}
              stepState={stepState}
              validateSelection={validateSelection}
              input={selectedItems}
              ReturnToArtPack={returnToArtPack}
              ReturnToCampaign={returnToCampaign}
              Previous={prevStep}
              Continue={nextStep}
              MintNft={createPreviewFile}
              restart={restart}
              color={data.web_main_color}
              campaign={campaign}
            />
          </div>
        </div>
        <div className="mint__box-mobile">
          <div className="mint__steps-mobile">
            {/* <div className="mint__steps-top">{renderStepPreview()}</div>
            <div className="mint__steps-bottom">{renderStep()}</div> */}
          </div>
          <MintFooter
            nextHover={`Please select a ${title} first`}
            nextButton={artOptions[stepState + 1]?.navButton || delayedName}
            backButton={artOptions[stepState - 1]?.navButton || delayedName}
            stepTotal={artOptions.length - 1}
            stepState={stepState}
            validateSelection={validateSelection}
            input={selectedItems}
            ReturnToArtPack={returnToArtPack}
            Previous={prevStep}
            Continue={nextStep}
            MintNft={openWarnModal}
            restart={restart}
            campaign={campaign}
          />
        </div>
      </section>
    );
  };

  return <React.Fragment>{renderContent()}</React.Fragment>;
};

Array.prototype.insert = function (index, ...items) {
  this.splice(index, 0, ...items);
};

export default Mint;
